import type { Song } from "src/@types/api-types";

import SortableSongItem from "./SongListItem/SortableSongItem";

interface DraggablesSongListProps {
	list: {
		globalIndex: number;
		song: Song;
	}[];
	elapsedTime?: boolean;
}

const DraggablesSongsList = ({
	list,
	elapsedTime,
}: DraggablesSongListProps) => {
	return (
		<>
			{list.map((item) => (
				<SortableSongItem
					key={item.globalIndex}
					item={item}
					elapsedTime={elapsedTime}
				/>
			))}
		</>
	);
};

export default DraggablesSongsList;
